function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("line", {
  x1: 8.33414,
  y1: 8.05078,
  x2: 23.8905,
  y2: 23.6071,
  stroke: "#93999E",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 23.8906,
  y1: 8.33365,
  x2: 8.33427,
  y2: 23.89,
  stroke: "#93999E",
  strokeWidth: 2,
  strokeLinecap: "round"
});
const SvgClose = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.9c02e9c5.svg";
export { ForwardRef as ReactComponent };